import { render, staticRenderFns } from "./PaymentProviderChip.vue?vue&type=template&id=16a52632&scoped=true&"
import script from "./PaymentProviderChip.vue?vue&type=script&lang=js&"
export * from "./PaymentProviderChip.vue?vue&type=script&lang=js&"
import style0 from "./PaymentProviderChip.vue?vue&type=style&index=0&id=16a52632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a52632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
